































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { Titles, Modules } from "@/interfaces/general";
import Alert from "@/components/Alert.vue";
import UpdatePwa from "@/components/updatePwa.vue";
import { GlobalMixin } from "@/mixins/global";

@Component({
  components: { UpdatePwa, Alert }
})
export default class App extends Mixins(GlobalMixin) {
  tab = 0;
  drawer = false;
  right_menu = false;
  search = "";
  all = false;
  panel: number[] = [];
  headers = [
    { text: "icon", value: "icon" },
    { text: "name", value: "name" }
  ];

  modules: Modules[] = [
    {
      title: "Reporting",
      path: "/MOS Blue.svg",
      items: [
        {
          name: "Weekly Operations",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Daily Operations",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Daily Processing",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Daily Mining",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Monthly Executive",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Monthly Operations",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Quarterly ESG",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Monthly Reconciliation",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Monthly Exploration",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Monthly KPI",
          icon: "mdi-file",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        }
      ]
    },
    {
      title: "Dashboards",
      path: "/MOS Green.svg",
      items: [
        {
          name: "Operations Production",
          icon: "mdi-gamepad",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Processing Performance",
          icon: "mdi-chart-arc",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Mining Performance",
          icon: "mdi-hammer",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "HSE Statistics",
          icon: "mdi-chart-bar",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Executive KPIs",
          icon: "mdi-chart-bar",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "ESG Reporting",
          icon: "mdi-battery",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Group Performance KPIs",
          icon: "mdi-speedometer",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Interactive Analyst Centre",
          icon: "mdi-square-outline",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Property License Management",
          icon: "mdi-bookmark",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Processing Benchmark",
          icon: "mdi-chart-line-variant",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Purchase Order Status",
          icon: "mdi-battery",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Mobile Plant KPI Analysis",
          icon: "mdi-focus-field-vertical",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Mining Benchmark",
          icon: "mdi-align-vertical-bottom",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Local Spend Analysis",
          icon: "mdi-nuxt",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "License and Permit Management",
          icon: "mdi-check-decagram",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Inventory Analysis",
          icon: "mdi-chart-tree",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Exploration",
          icon: "mdi-moon-waxing-gibbous",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Cost Driver Analysis",
          icon: "mdi-glass-stange",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Legal Contract Register",
          icon: "mdi-content-save-all",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Consolidated AP Analysis",
          icon: "mdi-consolidate",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Community Contribution",
          icon: "mdi-arrow-up-bold-circle",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Capital Project Analysis",
          icon: "mdi-atom-variant",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Asset Depreciation Schedules",
          icon: "mdi-google-cloud",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "AP Processing Performance",
          icon: "mdi-av-timer",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Supply & Procurement KPIs",
          icon: "mdi-axe",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        }
      ]
    },
    {
      title: "Tools",
      path: "/MOS Red.svg",
      items: [
        {
          name: "Access Manager",
          icon: "/Access Manager.svg",
          link: process.env.VUE_APP_ACCESS_MANAGER
        },
        {
          name: "Reconciliation",
          icon: "/Recon.svg",
          link: process.env.VUE_APP_RECONCILIATION
        },
        {
          name: "Metabase",
          icon: "mdi-chart-bar",
          link: process.env.VUE_APP_METABASE
        },
        {
          name: "Project Status",
          icon: "/Project Status.svg",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Integrated communication system",
          icon: "mdi-cube-outline",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Metallurgical Accounting",
          icon: "mdi-patreon",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Mine Production Data Capture",
          icon: "mdi-passport-biometric",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Consolidated Action Tracker",
          icon: "mdi-paperclip",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Monthly Finance and Forecast Uploader",
          icon: "mdi-currency-sign",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Production Schedule Manager",
          icon: "mdi-hazard-lights",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "New Project/Initiative Manager SPORT",
          icon: "mdi-pentagon",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Process Production Data Capture",
          icon: "mdi-heart-half",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Interval Travel / Logistics Manager",
          icon: "mdi-tooltip",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Group Roster Manager",
          icon: "mdi-dice-4",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "R&R Governance",
          icon: "mdi-disc",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Professional Development Manager",
          icon: "mdi-diving-flippers",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Mine Fleet Management",
          icon: "mdi-distribute-vertical-center",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Mobile Prestart App",
          icon: "mdi-betamax",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "OPEX Budget Builder",
          icon: "mdi-domain",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Endeavour Document Library",
          icon: "mdi-hvac",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Block Model Version Comparer",
          icon: "mdi-image-broken-variant",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Blend Model Version Comparer",
          icon: "mdi-image-filter-vintage",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Blend & Stockpile Evolution",
          icon: "mdi-inbox",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Projects Management and APE Submissions",
          icon: "mdi-vector-polyline",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        },
        {
          name: "Trail Balance Encurer",
          icon: "mdi-vibrate",
          link: process.env.VUE_APP_UNDER_CONSTRUCTION
        }
      ]
    }
  ];
  titles: Titles[] = [
    {
      title: "Mos",
      link: "/"
    },
    {
      title: "Ecosystem",
      link: "/ecosystem"
    },
    {
      title: "Modules",
      link: "/modules"
    },
    {
      title: "Status",
      link: "/status"
    },
    {
      title: "Contact",
      link: "/contact"
    }
  ];

  created() {
    if (localStorage.getItem("dark")) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      setTimeout(function() {
        self.$vuetify.theme.dark = localStorage.getItem("dark") === "true";
      }, 500);
    }
  }

  homeAction(): void {
    if (this.$route.path !== "/") this.$router.push({ path: "/" });
  }

  darkFunction(): void {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    localStorage.setItem("dark", JSON.stringify(this.$vuetify.theme.dark));
  }

  showAll() {
    this.all = !this.all;
    if (this.all) {
      this.openPanels();
    } else {
      this.panel = [0];
    }
  }

  showSearch() {
    this.all = true;
    this.openPanels();
  }

  openPanels() {
    this.panel = [...Array(this.modules.length).keys()];
    this.panel = this.panel.map(x => x + 1);
  }

  getImage(link: string): string {
    return require("@/assets" + link);
  }

  isImage(link: string): boolean {
    return link.startsWith("/");
  }
}
